import {InterfacePromotions} from "../../interface/interface.promotions";
import moment, { Moment } from 'moment';

type PluralCategory = Intl.LDMLPluralRule;

const getDayString = (count: number): string => {
    const rules = new Intl.PluralRules('ru-RU');
    const type = rules.select(count) as PluralCategory;
    const forms: Partial<Record<PluralCategory, string>> = {
        one: 'день',
        few: 'дня',
        many: 'дней',
        other: 'дней',
    };

    return forms[type] || 'дней';
};

export const promotionsTemplateHtml = (
    units: InterfacePromotions[],
) => {
    let contentResult: string = '';
    units.forEach((item: InterfacePromotions) => {
        const rawFromDate: Moment = moment(item.FromDate, 'DD.MM.YYYY HH:mm:ss');
        const rawToDate: Moment = moment(item.ToDate, 'DD.MM.YYYY HH:mm:ss');
        const currentDate = moment();

        let durationEventText = '<h6>Срок проведения: бессрочно</h6>';
        let endPromotion = '';
        let status = 'Активна';
        let styleClassStatus = 'is-valid';
        const withDate = item.FromDate ? 'с ': '';
        if (item.ToDate) {
            durationEventText = `
                <h6><span>Срок проведения:</span> ${withDate} ${item.FromDate ? moment(rawFromDate).format('DD.MM.YYYY') : ''} 
                 по ${moment(rawToDate).format('DD.MM.YYYY')}</h6>
            `;
            let daysEndPromotion = rawToDate.diff(currentDate, 'days');
            const minutesEndPromotion = rawToDate.diff(currentDate, 'minutes');
            if (minutesEndPromotion) {
                daysEndPromotion += 1;
            }
            if (daysEndPromotion > 0 && daysEndPromotion <= 7) {
                endPromotion = `
                    <div class="promotions__unit-completion-event mb-15">
                      <p>Акция завершается через:</p>
                      <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M16.5 9C16.5 13.14 13.14 16.5 9 16.5C4.86 16.5 1.5 13.14 1.5 9C1.5 4.86 4.86 1.5 9 1.5C13.14 1.5 16.5 4.86 16.5 9Z" stroke="#E02F2E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M11.7827 11.3853L9.45766 9.99781C9.05266 9.75781 8.72266 9.18031 8.72266 8.70781V5.63281" stroke="#E02F2E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                      <p>
                        ${daysEndPromotion}
                        ${getDayString(daysEndPromotion)}
                      </p>
                    </div>
                `
                status = 'Заканчивается';
                styleClassStatus = 'ending';
            }
            if (daysEndPromotion <= 0) {
                status = 'Завершена';
                styleClassStatus = 'completed';
            }
        }
        let discount = '';
        if (item.Discount) {
            discount = `
                <div class="promotions__unit-discount ${styleClassStatus}">
                  <svg width="92" height="93" viewBox="0 0 92 93" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect x="170.75" y="15.6172" width="115.528" height="132.395" rx="11" transform="rotate(135 170.75 15.6172)" fill="#FF383C"/>
                  </svg>
                  <h4>${item.IsDiscountExact ? '-' : '<span>до</span>' }${item.Discount}%</h4>
                </div>
            `;
        }
        contentResult
            += `
             <div class="promotions__unit">
                <div>
                    ${discount}
                    <h3 class="mb-25">${item.Header}</h3>
                    <div class="promotions__unit-body-wrap mb-15">
                      <p class="body">${item.Description ? item.Description.replace(/<[^>]*>/g, ''): ''}</p>
                    </div>
                    <div class="promotions__unit-duration-event mb-15">
                      <div class="promotions__unit-duration-event-date">
                          <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M6 1.5V3.75" stroke="#8B8B8B" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M12 1.5V3.75" stroke="#8B8B8B" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M2.625 6.82031H15.375" stroke="#8B8B8B" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M15.75 6.375V12.75C15.75 15 14.625 16.5 12 16.5H6C3.375 16.5 2.25 15 2.25 12.75V6.375C2.25 4.125 3.375 2.625 6 2.625H12C14.625 2.625 15.75 4.125 15.75 6.375Z" stroke="#8B8B8B" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                          </svg>
                          ${durationEventText}
                      </div>
                      <div class="promotions__unit-status mobile">
                        <p class="${styleClassStatus}">${status}</p>
                      </div>
                    </div>
                    ${endPromotion}
                </div>
                <div class="promotions__unit-status-button">
                  <div class="promotions__unit-status desktop">
                    <p class="${styleClassStatus}">${status}</p>
                  </div>
                  <a href="/акция/${item.Id}" class="button button__normal button__link">подробнее</a>
                </div>
              </div>
            `;
    });
    return contentResult;
}
